export const FETCH_GROUPS = 'FETCH_GROUPS';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_ME_SUCCESS = 'UPDATE_ME_SUCCESS';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const EMPTY_USERS = 'EMPTY_USERS';

export const fetchGroups = () => ({
  type: FETCH_GROUPS,
});

export const fetchGroupsSuccess = (data) => ({
  type: FETCH_GROUPS_SUCCESS,
  data,
});

export const fetchUsers = (data) => ({
  type: FETCH_USERS,
  data
});

export const fetchUsersSuccess = (data) => ({
  type: FETCH_USERS_SUCCESS,
  data
})

export const emptyUsers = () => ({
  type: EMPTY_USERS,
})

export const updateUser = (data) => ({
  type: UPDATE_USER,
  data,
})

export const updateUserSuccess = (data) => ({
  type: UPDATE_ME_SUCCESS,
  data
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/eadmin/actions.js
 **/